import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';
import { Avatar } from '../core/Avatar';
import { Checkbox } from '../forms/Checkbox';

export type Prioridade = 'alta' | 'media' | 'baixa';

const cores: Record<Prioridade, string> = {
    alta: 'var(--danger-strong)',
    media: 'var(--warning-strong)',
    baixa: 'var(--text-tertiary)',
};

export interface TaskCardProps {
    title?: ReactNode;
    /** Vencimento já formatado. */
    due?: ReactNode;
    owner?: string;
    done?: boolean;
    priority?: Prioridade;
    onToggle?: (done: boolean) => void;
    style?: CSSProperties;
}

export function TaskCard({ title, due, owner, done = false, priority, onToggle, style }: TaskCardProps) {
    const prio = priority ? cores[priority] : undefined;
    return (
        <article style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: 12, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', ...style }}>
            {/* A caixa não tem rótulo visível — o título está ao lado, mas fora
                do <label>. Sem nome acessível, dez tarefas viram dez "caixa de
                seleção" idênticas para quem ouve. */}
            <Checkbox
                checked={done} onChange={onToggle} style={{ marginTop: 1 }}
                ariaLabel={typeof title === 'string' ? `Concluir: ${title}` : 'Concluir tarefa'}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: 13.5, lineHeight: '19px', color: done ? 'var(--text-tertiary)' : 'var(--text-primary)', textDecoration: done ? 'line-through' : 'none' }}>
                    {title}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '2px 10px', marginTop: 6, fontSize: 12, color: 'var(--text-tertiary)' }}>
                    {due && <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}><Icon name="calendar" size={12} />{due}</span>}
                    {priority && <span style={{ color: prio, fontWeight: 600 }}>Prioridade {priority}</span>}
                </div>
            </div>
            {owner && <Avatar name={owner} size="xs" />}
        </article>
    );
}
